import { render, staticRenderFns } from "./descripcion.vue?vue&type=template&id=1dcb44e8&scoped=true"
import script from "./descripcion.vue?vue&type=script&lang=js"
export * from "./descripcion.vue?vue&type=script&lang=js"
import style0 from "./descripcion.vue?vue&type=style&index=0&id=1dcb44e8&prod&lang=scss&scoped=true"
import style1 from "./descripcion.vue?vue&type=style&index=1&id=1dcb44e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb44e8",
  null
  
)

export default component.exports